import { useQuery } from '@abyss/web/hooks/useQuery';
// @ts-ignore
import { ApiUrl } from '@src/common/ajax/apiUrl';
import FindProvider from './FindProvider.gql';

export const useFindProvider = (options) => {
  return useQuery(FindProvider, {
    ...options,
    url: ApiUrl.graphQl(),
    requestPolicy: 'no-cache',
  });
};
